module.exports = __webpack_public_path__ + "img/info-768.c03063ac.png";